<div class="gc-dashboard-wrapper">
  <div class="gc-side-nav" [ngClass]="toggleSidebar ? 'side-toggle' : ''">
    <div class="gc-logo" (click)="toggleSidebar = !toggleSidebar">
      <div class="gc-logo-icon">
        <img
          src="../../../assets/images/io-health-insignia.svg"
          alt="logo-icon.svg"
        />
      </div>
      <div class="gc-logo-text">
        <img src="../../../assets/images/logo-text.svg" alt="logo-text.svg" />
      </div>
    </div>
    <app-sidebar></app-sidebar>
  </div>
  <div class="h-screen overflow-auto w-full">
    <app-progress-bar></app-progress-bar>
    <app-header></app-header>
    <div class="gc-dashboard-contant">
      <app-preferences></app-preferences>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<app-overlay-banner [days]="days"></app-overlay-banner>
<!-- <app-footer></app-footer> -->
